import saveAs from 'file-saver'
import axios from 'axios'

const http = axios.create({
  baseURL: ''
})

export default (url, fileName) => {
  return http
    .get(url, {
      responseType: 'blob'
    })
    .then((res) => {
      saveAs(res.data, fileName)
      return true
    })
}
